
import { ChangeDetectionStrategy, Component, Input, input, signal } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';


import { exampleData, randomExampleContent } from 'src/app/styleguide/exampledata/example-data';

@Component({
    selector: 'app-content-accordeon',
    imports: [MatExpansionModule],
    templateUrl: './content-accordeon.component.html',
    styleUrl: './content-accordeon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentAccordeonComponent {
  @Input() datatitle?: string;
  @Input({
    transform: (v: string | boolean) => !!v,
  })
  isopen = false; // legacy
  @Input({
    transform: (v: string | boolean) => !!v,
  })
  dataisopen = false;
}
